export default __webpack_public_path__ + "static/media/red-arrow.04f32f4c.svg";